export { default } from './CapcaleraLite';
